module.exports = __webpack_public_path__ + "img/software-mode.c93bda48.png";